"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCategoryCircuitsQueryDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchCategoryCircuitsQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    search;
    featured;
    isArchived;
    categoryIds;
    tagIds;
    displayIds;
    /** Alias accepted by API clients that already use display search naming. */
    categories;
    /** Alias accepted by API clients that already use display search naming. */
    tags;
    /** Alias accepted by API clients that already use display search naming. */
    displays;
}
exports.SearchCategoryCircuitsQueryDto = SearchCategoryCircuitsQueryDto;
